module.exports = __webpack_public_path__ + "img/lehre4_c_tu_wien.8ac47d51.jpg";